module.exports = __webpack_public_path__ + "static/media/slickapp.dc79bb3f.png";